import React from 'react';

class Footer extends React.Component {
    render() {
        return (
            <footer>
            <a className="has-text-centered instagram-link" href="https://www.instagram.com/sherrycindy99/" target="_blank">
                  <span>See more on Instagram</span>
                  <div className="instagram-icon"></div>
            </a>
              <div className="container has-text-centered">
              <div className="section">
                <p><small>Site design by <a href="http://zackshave.com/">Zack Shave</a> & photos by Neil Boyle. Betty Hutchins, wordsmith.</small></p>
                <p>&copy; {(new Date()).getFullYear()} Cindy Sherry </p>
              </div>
              </div>
            </footer>
        )
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js